<template>
  <div :class="$style.wrapper">
    <ul v-if="hasUsers" :class="[$style.wrapper__list, $style.list]">
      <li
        v-for="karte in props.karten"
        :key="karte.id"
        :class="$style.list__item"
      >
        <KarteUserListItem :karte="karte" />
      </li>
    </ul>
    <div
      v-if="karten.length === 0 || hasNext"
      :class="[$style.wrapper__loader, $style.loader]"
    >
      <LoadingIndicator />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import LoadingIndicator from '@/components/atoms/LoadingIndicator.vue'
import KarteUserListItem from './KarteUserListItem.vue'
import { type KarteUserListItemKarteFragment } from './KarteUserListItem.generated'

const props = withDefaults(
  defineProps<{
    karten: KarteUserListItemKarteFragment[]
    hasNext: boolean
  }>(),
  {
    users: () => [],
    hasNext: false,
  }
)

const hasUsers = computed(() => props.karten.length !== 0)
</script>

<style lang="scss" module>
.wrapper {
  height: 100%;

  &__loader {
    &:first-child {
      height: 100%;
    }

    &:nth-child(n + 2) {
      height: 160px;
    }
  }
}

.list {
  $cardwidth: 344px;

  display: grid;
  grid-gap: 12px;
  grid-template-columns: repeat(auto-fill, minmax($cardwidth, 1fr));

  &__item {
    background-color: $color-surface-primary;
    border-radius: $border-radius-v2-rounder;
    box-shadow: $shadow-20;
  }
}

.link {
  display: block;
}

.loader {
  display: flex;
  place-content: center;
}
</style>
